import type { SpreadsheetDocument } from 'models/SpreadsheetDocument';

export const REFERENCE_KINDS = [
  ['light_camera', '전방위(조명) CCTV'],
  ['warning_camera', '단방향 CCTV'],
  ['camera', 'CCTV 전체'],
  ['parking', '주차구역'],
  ['emergency', '비상벨'],
  ['light', '조명'],
  ['pillar', '기둥'],
  ['material', '기타 자재 · 품명으로 비교'],
  ['exclude', '비교 제외 · 합계/메모 행'],
] as const;

const key = (value: string) => value.replace(/[\s_]/g, '').toLowerCase();

export function suggestReferenceKind(name: string): string {
  const aliases: Record<string, string> = {
    전방위카메라cctv: 'light_camera',
    전방위cctv: 'light_camera',
    조명cctv: 'light_camera',
    단방향카메라cctv: 'warning_camera',
    단방향cctv: 'warning_camera',
    cctv: 'camera',
    카메라: 'camera',
    주차면: 'parking',
    주차구역: 'parking',
    비상벨: 'emergency',
    무선비상벨: 'emergency',
    조명: 'light',
    조명기구: 'light',
    기둥: 'pillar',
  };
  return aliases[key(name)] || '';
}

export function suggestReferenceColumns(doc: SpreadsheetDocument) {
  const find = (names: string[]) =>
    doc.columns.find((c) => names.some((n) => key(n) === key(c.name)))?.id ||
    '';
  return {
    name_column: find([
      '품명',
      '품목',
      '자재명',
      '카테고리',
      '장비 종류',
      '이름',
      'name',
    ]),
    quantity_column: find(['수량', 'qty', 'quantity']),
    floor_column: find(['층', '층명', 'floor']),
    unit_column: find(['단위', 'unit']),
    ip_column: find(['시작 IP 주소', '시작 IP', 'IP 주소', 'IP']),
    end_ip_column: find(['끝 IP 주소', '끝 IP', '종료 IP', 'END IP']),
  };
}
